var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m15 6.667-.833.555v0c-1.342.894-2.012 1.342-2.724 1.556a5 5 0 0 1-2.885 0c-.713-.214-1.383-.662-2.725-1.556v0L5 6.667M9.167 17.5h1.666c2.33 0 3.495 0 4.414-.38a5 5 0 0 0 2.706-2.707c.38-.918.38-2.083.38-4.413v0c0-2.33 0-3.495-.38-4.413a5 5 0 0 0-2.706-2.706c-.919-.381-2.084-.381-4.414-.381H9.167c-2.33 0-3.495 0-4.414.38a5 5 0 0 0-2.706 2.707c-.38.918-.38 2.083-.38 4.413v0c0 2.33 0 3.495.38 4.413a5 5 0 0 0 2.706 2.706c.92.381 2.084.381 4.414.381Z"
  })));
};
export default SvgEmail;